import React from "react";
import { FileText } from "lucide-react";
import GSTReportForm from "./Components/GstReportComponents/GSTReportForm";
import BreadCrumbsContainer from "../../../Components/Common/Breadcrumbs";

const GSTReports = () => {
  return (
    <div>
      <div className="bg-white h-[calc(100vh-120px)] rounded-lg overflow-auto">
        {/* Header Section */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h1 className="text-2xl font-semibold font-outfit text-gray-800">
            GST Reports
          </h1>
        </div>

        <GSTReportForm />
      </div>
    </div>
  );
};

export default GSTReports;
